@if (loading) {
    <div class="table-orders__loading">
        <div class="table-skeleton">
            <!-- Header -->
            @if (showHeader) {
                <div class="table-skeleton__header">
                    @for (column of columnsArray; track column) {
                        <div
                            class="table-skeleton__header-cell"
                            [style.width]="columnWidthsArray[column]"
                            [style.height]="headerHeight"
                        >
                            <div class="skeleton-item" [style.height]="headerHeight"></div>
                        </div>
                    }
                </div>
            }

            <!-- Body -->
            <div class="table-skeleton__body">
                @for (row of rowsArray; track row) {
                    <div class="table-skeleton__row">
                        @for (column of columnsArray; track column) {
                            <div
                                class="table-skeleton__cell"
                                [style.width]="columnWidthsArray[column]"
                                [style.height]="rowHeight"
                            >
                                <div class="skeleton-item" [style.height]="rowHeight"></div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
}
